// imports
import JsonApiCollection from '$dependencies/JsonApiCollection';
import BinColorModel from '$models/bin/BinColorModel';
import Config from '$root/Config';

// class definition
export default class BinColorCollection extends JsonApiCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinColorModel;
		args.config = {
			url: Config.getUrl('binColors'),
		};
		args.jsonApi = { order: { weight: 'asc' } };
		// call super constructor
		super(args);
	}
}
